// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"5679812b","389":"df8ae68f","828":"9c7bb60e","874":"50bad020"}[chunkId] + ".chunk.js";
};